import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  getEventsStart,
  getEventsSuccess,
  getEventsFailed,
} from "../redux/filterEvent";
import { toast } from "react-toastify";
import { getListEventApi } from "core/http/service/interviewSchedule";
import { formFilterSelector } from "../redux/selector";

function* getEventsWork(action) {
  const screenCode = action.payload?.screenCode;
  const filterForm = yield select(formFilterSelector);
  const payload = {
    ...filterForm,
    programCode: filterForm?.programCode?.map((item) => item.value).join(","),
  };

  try {
    const res = yield call(getListEventApi, { ...payload, screenCode });
    yield put({
      type: getEventsSuccess.type,
      payload: {
        data: res?.data,
      },
    });
  } catch (error) {
    yield put({
      type: getEventsFailed.type,
    });
    if (error?.response?.data?.businessError) {
      toast.error(error?.response?.data?.businessError?.[0].message);
    } else {
      toast.error("Đã có lỗi xảy ra!");
    }
  }
}

function* watchGetEvents() {
  yield takeLatest(getEventsStart.type, getEventsWork);
}
export default function* getEventsSaga() {
  yield all([watchGetEvents()]);
}
